
import { postRequest } from "../httpMethods";

export const postAddTeacher = (payload) =>
    postRequest(`school/teachers`, payload);

export const postAssignCourseToTeachers= (payload) =>
    postRequest(`school/assign-course`, payload);





